import { DEFAULT_ONBOARDING_STATE } from './consts';
import { OnboardingAction, OnboardingActionTypes, OnboardingState } from './types';

export const onboardingReducer = (state: OnboardingState, action: OnboardingAction): OnboardingState => {
  switch (action.type) {
    case OnboardingActionTypes.SET_IN_FLOW: {
      return {
        ...state,
        inFlow: action.inFlow,
      };
    }
    case OnboardingActionTypes.SET_FLOW_TYPE: {
      return {
        ...state,
        flowType: action.flowType,
      };
    }
    case OnboardingActionTypes.SET_IS_TEMPLATE_FLOW: {
      return {
        ...state,
        isTemplateMode: action.isTemplateMode,
      };
    }
    case OnboardingActionTypes.RESET_STATE: {
      return {
        ...state,
        ...DEFAULT_ONBOARDING_STATE,
      };
    }
    default:
      return state;
  }
};
